var _style, _rect, _polygon, _polygon2, _defs, _path, _polygon3, _polygon4, _path2, _polygon5, _polygon6, _polygon7, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKuLeuvenLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 133.18 47.56",
    style: {
      enableBackground: "new 0 0 133.18 47.56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00407A;}\r\n\t.st1{fill:#54BCEB;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.76,
    y: 4.76,
    className: "st0",
    width: 128.42,
    height: 42.81
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,0 0,47.56 4.76,47.56 4.76,4.76 133.17,4.76 133.17,0 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "14.27,19.03 18.52,19.03 18.52,23.94 18.56,23.94 22.35,19.03 27.6,19.03 22.59,24.6 28.41,33.29  23.11,33.29 19.7,27.74 18.52,29.08 18.52,33.29 14.27,33.29 "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0,
    width: 133.17,
    height: 47.56
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.17,27.77c0,3.95-2.07,5.85-6.29,5.85s-6.31-1.9-6.31-5.85v-8.75h4.26v7.77c0,1.46,0,3.27,2.07,3.27 c2.01,0,2.01-1.82,2.01-3.27v-7.77h4.26V27.77z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "47.42,19.03 51.67,19.03 51.67,29.64 57.68,29.64 57.68,33.29 47.42,33.29  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "58.98,19.03 70.3,19.03 70.3,22.68 63.19,22.68 63.19,24.46 69.65,24.46 69.65,27.86 63.19,27.86  63.19,29.64 70.51,29.64 70.51,33.29 58.98,33.29  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.2,27.77c0,3.95-2.07,5.85-6.29,5.85c-4.22,0-6.3-1.9-6.3-5.85v-8.75h4.25v7.77c0,1.46,0,3.27,2.07,3.27 c2.01,0,2.01-1.82,2.01-3.27v-7.77h4.26V27.77z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "93.68,33.29 88.92,33.29 84.8,19.03 89.09,19.03 91.36,27.68 91.39,27.68 93.62,19.03 97.99,19.03  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "98.59,19.03 109.91,19.03 109.91,22.68 102.81,22.68 102.81,24.46 109.26,24.46 109.26,27.86  102.81,27.86 102.81,29.64 110.13,29.64 110.13,33.29 98.59,33.29  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "111.23,19.03 115.58,19.03 119.6,26.66 119.64,26.66 119.64,19.03 123.66,19.03 123.66,33.29  119.52,33.29 115.29,25.5 115.25,25.5 115.25,33.29 111.23,33.29  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuLeuvenLogo);
export default __webpack_public_path__ + "static/media/KU_Leuven_logo.f8245048902b36c7bf3c8bd8a2f7b414.svg";
export { ForwardRef as ReactComponent };